import { render, staticRenderFns } from "./postWork.vue?vue&type=template&id=1229da68&"
import script from "./postWork.vue?vue&type=script&lang=js&"
export * from "./postWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports